export default __webpack_public_path__ + "static/media/Tasset of the Doomsayer.0dbc3b09.jpg";